module.exports = __webpack_public_path__ + "img/company15.dbd8ab11.png";